// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[2].use[2]!../../styles/typography.css";
import ___CSS_LOADER_ICSS_IMPORT_1___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[2].use[2]!./settings.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_1___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * == BSD2 LICENSE ==
 * Copyright (c) 2016, Tidepool Project
 *
 * This program is free software; you can redistribute it and/or modify it under
 * the terms of the associated License, which is identical to the BSD 2-Clause
 * License as published by the Open Source Initiative at opensource.org.
 *
 * This program is distributed in the hope that it will be useful, but WITHOUT
 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
 * FOR A PARTICULAR PURPOSE. See the License for more details.
 *
 * You should have received a copy of the License along with this program; if
 * not, you can obtain one from Tidepool Project at tidepool.org.
 * == BSD2 LICENSE ==
 */

.NonTandem--header--shbF9 {
  display: flex;
  justify-content: space-between;

  align-items: center;
  align-content: center;
}

.NonTandem--settingsContainer--wyIve {
  align-items: flex-start;
  display: flex;
  justify-content: space-between;
  gap: 10px;
}

.NonTandem--settingsContainerLeftAligned--tI0p2 {
  justify-content: flex-start;
  display: block;
}

.NonTandem--insulinSettingsInnerContainer--nmzyd {
  display: block;
  width: 100%;
}

.NonTandem--insulinSettingsInnerContainer--nmzyd > div {
  display: block;
  float: left;
  width: auto;
  padding-right: 10px;
}

.NonTandem--insulinSettingsInnerContainer--nmzyd > div:first-child {
  min-width: 25% !important;
}

.NonTandem--insulinSettingsInnerContainer--nmzyd > div:last-child {
  padding-right: 0;
  clear: right;
}

.NonTandem--basalSettingsContainer--C772m {
  flex-basis: 25%;
  margin-bottom: 15px;
}

.NonTandem--bolusSettingsContainer--QMZiq {
  display: flex;
  flex-wrap: wrap;
  flex-basis: 75%;
  margin-bottom: 15px;
}

.NonTandem--bolusSettingsInnerContainer--kCMVT {
  display: flex;
  flex-flow: row wrap;
  width: 100%;
  gap: 10px;
}

.NonTandem--categoryTitle--h0b71 {
  width: 100%;
  padding-bottom: 10px;
}

.NonTandem--categoryContainer--kMddv {
  margin-bottom: 10px;
  width: 100%;
  flex: 1;
}

.NonTandem--bolusSettingsInnerContainer--kCMVT .NonTandem--categoryContainer--kMddv:last-child {
  padding-right: 0;
}

.NonTandem--basalTable--fkAEf {
}

.NonTandem--basalTable--fkAEf td:first-child, .NonTandem--basalTable--fkAEf th:first-child {
  padding-left: 28px;
}

.NonTandem--settingsTable--bvSw8 {
}

.NonTandem--settingsTableInverted--XW7S0 {
}

.NonTandem--settingsTable--bvSw8 td:first-child, .NonTandem--settingsTable--bvSw8 th:first-child,
.NonTandem--settingsTableInverted--XW7S0 td:first-child, .NonTandem--settingsTableInverted--XW7S0 th:first-child {
  padding-left: 28px;
}

.NonTandem--singleLineBasalScheduleHeader--ESKnN {
  justify-content: space-between;
}

.NonTandem--automatedSingleLineBasalScheduleHeader--kIDJ7 {
  justify-content: space-between;
  font-size: 16px;
  padding: 0;
}

.NonTandem--twoLineBasalScheduleHeader--xYjZD {
}

.NonTandem--twoLineBasalScheduleHeader--xYjZD > div:first-child {
  padding-left: 0;
}

.NonTandem--insulinSettingsHeader--EtP0j {
}

.NonTandem--presetSettingsHeader--Ncjal {
}

.NonTandem--bolusSettingsHeader--A_g8e {
}

.NonTandem--automatedBasalHeaderBackground--MyDbN {
  text-align: left;
  padding-left: 28px;
  padding-top: 8px;
  padding-bottom: 8px
}

.NonTandem--automatedBasalHeaderBackground--MyDbN > span {
  padding-left: 5px;
}

@media print {

  .NonTandem--categoryContainer--kMddv {
    max-width: 280px;
    min-width: 250px;
    width: 100%;
    margin-bottom: 10px;
    margin-right: 10px;
  }

  .NonTandem--settingsContainer--wyIve {
    display: block;
  }

  .NonTandem--basalSettingsContainer--C772m {
    display: flex;
    flex-flow: row wrap;
    justify-content: flex-start;
    page-break-after: auto;
  }

  .NonTandem--categoryTitle--h0b71 {
    font-weight: normal;
    font-size: 20px;
    color: var(--text-black);
    width: 100%;
    padding-bottom: 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/settings/NonTandem.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;EAeE;;AAEF;EACE,aAAa;EACb,8BAA8B;;EAE9B,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EAEE,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,SAAS;AACX;;AAEA;EAEE,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,OAAO;AACT;;AAEA;EACE,gBAAgB;AAClB;;AAEA;AAEA;;AAEA;EACE,kBAAkB;AACpB;;AAEA;AAEA;;AAEA;AAEA;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EAEE,8BAA8B;AAChC;;AAEA;EAEE,8BAA8B;EAC9B,eAAe;EACf,UAAU;AACZ;;AAEA;AAEA;;AAEA;EACE,eAAe;AACjB;;AAEA;AAEA;;AAEA;AAEA;;AAEA;AAEA;;AAEA;EAEE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB;AACF;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE;IACE,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;IACnB,eAAe;IACf,wBAAwB;IACxB,WAAW;IACX,oBAAoB;EACtB;AACF","sourcesContent":["/*\n * == BSD2 LICENSE ==\n * Copyright (c) 2016, Tidepool Project\n *\n * This program is free software; you can redistribute it and/or modify it under\n * the terms of the associated License, which is identical to the BSD 2-Clause\n * License as published by the Open Source Initiative at opensource.org.\n *\n * This program is distributed in the hope that it will be useful, but WITHOUT\n * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS\n * FOR A PARTICULAR PURPOSE. See the License for more details.\n *\n * You should have received a copy of the License along with this program; if\n * not, you can obtain one from Tidepool Project at tidepool.org.\n * == BSD2 LICENSE ==\n */\n\n.header {\n  display: flex;\n  justify-content: space-between;\n\n  align-items: center;\n  align-content: center;\n}\n\n.settingsContainer {\n  align-items: flex-start;\n  display: flex;\n  justify-content: space-between;\n  gap: 10px;\n}\n\n.settingsContainerLeftAligned {\n  composes: settingsContainer;\n  justify-content: flex-start;\n  display: block;\n}\n\n.insulinSettingsInnerContainer {\n  display: block;\n  width: 100%;\n}\n\n.insulinSettingsInnerContainer > div {\n  display: block;\n  float: left;\n  width: auto;\n  padding-right: 10px;\n}\n\n.insulinSettingsInnerContainer > div:first-child {\n  min-width: 25% !important;\n}\n\n.insulinSettingsInnerContainer > div:last-child {\n  padding-right: 0;\n  clear: right;\n}\n\n.basalSettingsContainer {\n  flex-basis: 25%;\n  margin-bottom: 15px;\n}\n\n.bolusSettingsContainer {\n  display: flex;\n  flex-wrap: wrap;\n  flex-basis: 75%;\n  margin-bottom: 15px;\n}\n\n.bolusSettingsInnerContainer {\n  display: flex;\n  flex-flow: row wrap;\n  width: 100%;\n  gap: 10px;\n}\n\n.categoryTitle {\n  composes: mediumContrastText from '../../styles/typography.css';\n  width: 100%;\n  padding-bottom: 10px;\n}\n\n.categoryContainer {\n  margin-bottom: 10px;\n  width: 100%;\n  flex: 1;\n}\n\n.bolusSettingsInnerContainer .categoryContainer:last-child {\n  padding-right: 0;\n}\n\n.basalTable {\n  composes: basalTable from './settings.css';\n}\n\n.basalTable td:first-child, .basalTable th:first-child {\n  padding-left: 28px;\n}\n\n.settingsTable {\n  composes: settingsTable from './settings.css';\n}\n\n.settingsTableInverted {\n  composes: settingsTableInverted from './settings.css';\n}\n\n.settingsTable td:first-child, .settingsTable th:first-child,\n.settingsTableInverted td:first-child, .settingsTableInverted th:first-child {\n  padding-left: 28px;\n}\n\n.singleLineBasalScheduleHeader {\n  composes: basalHeaderBackground settingsHeader from './settings.css';\n  justify-content: space-between;\n}\n\n.automatedSingleLineBasalScheduleHeader {\n  composes: automatedBasalHeaderBackground settingsHeader from './settings.css';\n  justify-content: space-between;\n  font-size: 16px;\n  padding: 0;\n}\n\n.twoLineBasalScheduleHeader {\n  composes: basalHeaderBackground settingsHeaderDecoration settingsHeaderLayout settingsHeaderText from './settings.css';\n}\n\n.twoLineBasalScheduleHeader > div:first-child {\n  padding-left: 0;\n}\n\n.insulinSettingsHeader {\n  composes: bolusHeaderBackground settingsHeader from './settings.css';\n}\n\n.presetSettingsHeader {\n  composes: presetsHeaderBackground settingsHeader from './settings.css';\n}\n\n.bolusSettingsHeader {\n  composes: bolusHeaderBackground settingsHeader from './settings.css';\n}\n\n.automatedBasalHeaderBackground {\n  composes: automatedBasalHeaderBackground from './settings.css';\n  text-align: left;\n  padding-left: 28px;\n  padding-top: 8px;\n  padding-bottom: 8px\n}\n\n.automatedBasalHeaderBackground > span {\n  padding-left: 5px;\n}\n\n@media print {\n\n  .categoryContainer {\n    max-width: 280px;\n    min-width: 250px;\n    width: 100%;\n    margin-bottom: 10px;\n    margin-right: 10px;\n  }\n\n  .settingsContainer {\n    display: block;\n  }\n\n  .basalSettingsContainer {\n    display: flex;\n    flex-flow: row wrap;\n    justify-content: flex-start;\n    page-break-after: auto;\n  }\n\n  .categoryTitle {\n    font-weight: normal;\n    font-size: 20px;\n    color: var(--text-black);\n    width: 100%;\n    padding-bottom: 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `NonTandem--header--shbF9`,
	"settingsContainer": `NonTandem--settingsContainer--wyIve`,
	"settingsContainerLeftAligned": `NonTandem--settingsContainerLeftAligned--tI0p2 NonTandem--settingsContainer--wyIve`,
	"insulinSettingsInnerContainer": `NonTandem--insulinSettingsInnerContainer--nmzyd`,
	"basalSettingsContainer": `NonTandem--basalSettingsContainer--C772m`,
	"bolusSettingsContainer": `NonTandem--bolusSettingsContainer--QMZiq`,
	"bolusSettingsInnerContainer": `NonTandem--bolusSettingsInnerContainer--kCMVT`,
	"categoryTitle": `NonTandem--categoryTitle--h0b71 ${___CSS_LOADER_ICSS_IMPORT_0___.locals["mediumContrastText"]}`,
	"categoryContainer": `NonTandem--categoryContainer--kMddv`,
	"basalTable": `NonTandem--basalTable--fkAEf ${___CSS_LOADER_ICSS_IMPORT_1___.locals["basalTable"]}`,
	"settingsTable": `NonTandem--settingsTable--bvSw8 ${___CSS_LOADER_ICSS_IMPORT_1___.locals["settingsTable"]}`,
	"settingsTableInverted": `NonTandem--settingsTableInverted--XW7S0 ${___CSS_LOADER_ICSS_IMPORT_1___.locals["settingsTableInverted"]}`,
	"singleLineBasalScheduleHeader": `NonTandem--singleLineBasalScheduleHeader--ESKnN ${___CSS_LOADER_ICSS_IMPORT_1___.locals["basalHeaderBackground"]} ${___CSS_LOADER_ICSS_IMPORT_1___.locals["settingsHeader"]}`,
	"automatedSingleLineBasalScheduleHeader": `NonTandem--automatedSingleLineBasalScheduleHeader--kIDJ7 ${___CSS_LOADER_ICSS_IMPORT_1___.locals["automatedBasalHeaderBackground"]} ${___CSS_LOADER_ICSS_IMPORT_1___.locals["settingsHeader"]}`,
	"twoLineBasalScheduleHeader": `NonTandem--twoLineBasalScheduleHeader--xYjZD ${___CSS_LOADER_ICSS_IMPORT_1___.locals["basalHeaderBackground"]} ${___CSS_LOADER_ICSS_IMPORT_1___.locals["settingsHeaderDecoration"]} ${___CSS_LOADER_ICSS_IMPORT_1___.locals["settingsHeaderLayout"]} ${___CSS_LOADER_ICSS_IMPORT_1___.locals["settingsHeaderText"]}`,
	"insulinSettingsHeader": `NonTandem--insulinSettingsHeader--EtP0j ${___CSS_LOADER_ICSS_IMPORT_1___.locals["bolusHeaderBackground"]} ${___CSS_LOADER_ICSS_IMPORT_1___.locals["settingsHeader"]}`,
	"presetSettingsHeader": `NonTandem--presetSettingsHeader--Ncjal ${___CSS_LOADER_ICSS_IMPORT_1___.locals["presetsHeaderBackground"]} ${___CSS_LOADER_ICSS_IMPORT_1___.locals["settingsHeader"]}`,
	"bolusSettingsHeader": `NonTandem--bolusSettingsHeader--A_g8e ${___CSS_LOADER_ICSS_IMPORT_1___.locals["bolusHeaderBackground"]} ${___CSS_LOADER_ICSS_IMPORT_1___.locals["settingsHeader"]}`,
	"automatedBasalHeaderBackground": `NonTandem--automatedBasalHeaderBackground--MyDbN ${___CSS_LOADER_ICSS_IMPORT_1___.locals["automatedBasalHeaderBackground"]}`
};
export default ___CSS_LOADER_EXPORT___;
